<template>
    <div class="horizontal grow gallery-container" style="width: 70vw; height: 70vh">
        <div id="info-container">
            <p class="section-title">{{ $t('SYSTEM_INFORMATION') }}</p>
            <div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">{{ $t('SystemName') }}</td>
                        <td class="info-field-value">{{ systemObject.systemName }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">{{ $t('Address') }}</td>
                        <td class="info-field-value">{{ systemObject.address }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">{{ $t('Country') }}</td>
                        <td class="info-field-value">{{ systemObject.country }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">{{ $t('Description') }}</td>
                        <td class="info-field-value">{{ systemObject.description }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">{{ $t('InstallationDate') }}</td>
                        <td class="info-field-value">{{ systemObject.installationDate }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">{{ $t('UnderWarranty') }}</td>
                        <td class="info-field-value">{{ systemObject.underWarranty }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">{{ $t('ServiceAgreement') }}</td>
                        <td class="info-field-value">{{ systemObject.serviceAgreement }}</td>
                    </tr>
                </div>
            </div>
        </div>
        <div id="photos-container" style="margin: auto;">
            <div class="vertical" style="margin: auto;" v-if="photos.length > 0">
                <div style="width: 35vw; height: 60vh; align-self: center; text-align: center; overflow: hidden; white-space: nowrap;">
                    <i class="arrow left" :style="[photos.length > 1 ? {'cursor': 'pointer' } : {'cursor': 'default'}]" @click="prevPhoto"></i>
                    <img class="photo" :src="photos[activePhotoIndex].src" >
                    <i class="arrow right" :style="[photos.length > 1 ? {'cursor': 'pointer' } : {'cursor': 'default'}]" @click="nextPhoto"></i>
                </div>
                <div class="thumbnails horizontal">
                    <div v-for="(photo, index) in photos" :key="index" @click="activePhotoIndex = index">
                        <img :src="photo.src" class="thumbnail"/>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {getSystemImage} from '@/api/api'

export default {
    props: {
        systemObject: {
            type: Object,
            required: true
        }
    },
    components: {
        // Lingallery
    },
    data() {
        return {
            photos: [],
            activePhotoIndex: 0,
        }
    },
    methods: {
        async getPhotos() {
          for (let i = 0; i < this.systemObject.images.length; i++) {

            let img = await getSystemImage(this.systemObject.images[i]);
            let photo = URL.createObjectURL(new Blob([img.data], {
              type: img.headers['content-type']}));

            this.photos.push({
              src : photo,
              thumbnail: photo,
              id: this.systemObject.images[i]
            });
          }
        },
        nextPhoto() {
          if (this.activePhotoIndex + 1 < this.photos.length) {
            this.activePhotoIndex++;
          }
        },
        prevPhoto() {
          if (this.activePhotoIndex > 0) {
            this.activePhotoIndex--;
          }
        },
        keyDownListener(e) {
          switch(e.key) {
            case 'ArrowLeft':
              this.prevPhoto();
              break;
            case 'ArrowRight':
              this.nextPhoto();
              break;
          }
        }
    },
    mounted: async function() {
        this.getPhotos()

        document.addEventListener("keydown", this.keyDownListener);
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.keyDownListener);
    }
}
</script>

<style scoped>
#info-container {
    width: 40%;
    padding: 20px;

    background: #FFFFFF;
    border: 1px solid #EFEFEF;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px 0px 0px 5px;
}

#photos-container {
    width: 100%;
}

.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

.photo {
    margin: 0 auto 0 auto;
    border-radius: 4px;
    object-fit: contain;
    width: 88%;
    height: 100%;
}

.thumbnails {
    overflow-y: hidden;
    overflow-x: scroll;
    max-width: 80%;
    margin: 0 auto 0 auto;
}

.thumbnail {
    width: 64px;
    height: 64px;
    margin: 5px;
    object-fit: cover;
    cursor: pointer;
    background: #34758E;
    border-radius: 4px;
}

.section-title {
    font-weight: bold;
}

.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  /* padding: 3px; */
  width: 4%;
  height: 0;
  padding-bottom: 4%;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/GalleryModal.vue